import Icon from '../Icon';
import { IconSpecificProps } from '../Icon.types';

const IconCloseCircle = ({ className, titleAccess }: IconSpecificProps) => (
  <Icon
    width="36"
    height="36"
    className={className}
    titleAccess={titleAccess}
    dataTestId="close-button">
    <rect x="0.5" y="0.5" width="35" height="35" rx="17.5" stroke="#0C3D3D" />
    <path
      d="M24.6673 11.3828L11.334 24.7161M11.334 11.3828L24.6673 24.7161"
      stroke="#0C3D3D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </Icon>
);

export default IconCloseCircle;
